import React, { useState, useEffect } from "react";
import SubCont from "@mui/material/Box";
import logo from "../../images/logoNew.png";
import Container from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import LoginImg from "../../images/loginDoctorImage.webp";
import TextField from "@mui/material/TextField";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import axios from "axios";
import { IconButton, InputAdornment } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { loginApi } from "../Api/Auth";
import ForgotPasswordModal from "./ForgotPassword";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const MainContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 5%;
`;

const Heading = styled.div`
  color: black;
  font-size: 30px;
  font-weight: 600;
  padding: 10px;
`;

const SubHeading = styled.div`
  color: #313131;
  font-size: 16px;
  font-weight: 400;
  padding: 5px 10px;
`;

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: window.innerWidth < 480 ? "85%" : "60%",
  bgcolor: "background.paper",
  boxShadow: 24,
  outline: "none",
  p: 1,
};

const MarketingLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
    const { executeRecaptcha } = useGoogleReCaptcha();

  const [errorMessage, setErrorMessage] = useState("");
  const [openForm, setOpenForm] = useState(true);
  const [isLoading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  
  // Captcha states
  const [captcha, setCaptcha] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaId, setCaptchaId] = useState("");

  // Fetch captcha on component mount
  const fetchCaptcha = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/Auth/GenerateCaptcha`,
        { responseType: "arraybuffer" }
      );
      
      // Get captcha ID from response headers
      const captchaIdFromHeader = response.headers['x-captcha-id'];
      setCaptchaId(captchaIdFromHeader || "");
      
      const base64 = btoa(
        new Uint8Array(response.data)
          .reduce((data, byte) => data + String.fromCharCode(byte), "")
      );

      setCaptcha("data:image/png;base64," + base64);
      setCaptchaInput("");
    } catch (error) {
      console.error("Error fetching captcha:", error);
    }
  };

  useEffect(() => {
    fetchCaptcha();
  }, []);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleLogin = async () => {
 setLoading(true);
      setErrorMessage("");
     if (!executeRecaptcha) {
     setErrorMessage('reCAPTCHA not ready. Please try again.');
      setLoading(false);
      return;
    }

    // ✅ FIX 3: Call executeRecaptcha ONCE (removed duplicate)
    const recaptchaToken = await executeRecaptcha('callback_request');

    if (!recaptchaToken) {
     setErrorMessage('Captcha verification failed. Please try again.');
      setLoading(false);
      return;
    }
    try {
     

      if (!formData.username || !formData.password) {
        setErrorMessage("Please enter both username and password");
        return;
      }

      // Validate captcha
      if (!captchaInput) {
        setErrorMessage("Please enter the captcha");
        return;
      }

      const response = await loginApi(
        formData.username, 
        formData.password, 
        captchaId, 
        parseInt(captchaInput),
        
      );


      if (response.isSuccess) {
        sessionStorage.setItem("userId", response.userId?.toString());
        sessionStorage.setItem("roleName", response.roleName?.toString());
        sessionStorage.setItem("fullName", response.fullName);
        sessionStorage.setItem("departmentId", response.departmentId?.toString());

        navigate("/dashboard");
      } else {
        setErrorMessage(response.message || "Login failed");
        fetchCaptcha();
      }
    } catch (error: any) {
      console.error("error in Marketing Login", error);
     setErrorMessage(error.message || "Login failed. Please try again.");
      fetchCaptcha();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      open={openForm}
      aria-labelledby="modal-modal-title"
      onClick={() => navigate("/Login")}
    >
      <div>
        {showForgotPassword && (
          <ForgotPasswordModal
            open={showForgotPassword}
            onClose={() => setShowForgotPassword(false)}
          />
        )}

        {/* Mobile View */}
        <div
          className="block md:hidden absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white shadow-2xl outline-none rounded-2xl w-[92%] max-h-[85vh] overflow-y-auto"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="px-6 py-8 pt-8">
            <div className="text-center space-y-6">
              <div className="space-y-3">
                <div className="w-full max-w-[150px] flex items-center justify-center mx-auto mb-3">
                  <img src={logo} alt="" className="" />
                </div>
                <p className="text-gray-600 text-sm leading-relaxed px-2">
                  Login to access your account
                </p>
              </div>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleLogin();
                }}
                className="space-y-5"
              >
                <div className="space-y-4 text-left">
                  <TextField
                    required
                    label="Username"
                    name="username"
                    value={formData.username}
                    fullWidth
                    size="small"
                    onChange={handleChange}
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "52px",
                        borderRadius: "16px",
                        fontSize: "16px",
                      },
                    }}
                  />

                  <TextField
                    required
                    label="Password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    value={formData.password}
                    fullWidth
                    size="small"
                    onChange={handleChange}
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "52px",
                        borderRadius: "16px",
                        fontSize: "16px",
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowPassword((prev) => !prev)}
                            edge="end"
                            size="small"
                            sx={{
                              p: 0.5,
                              "& svg": { fontSize: "1rem" },
                            }}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />

                  {/* Captcha Component - Mobile */}
                  <div className="flex items-center space-x-2">
                    <img
                      src={captcha}
                      alt="captcha"
                      className="w-32 h-10 border rounded"
                    />

                    <button
                      type="button"
                      onClick={fetchCaptcha}
                      className="p-0.5 bg-blue-500 hover:bg-green-600 rounded-full flex items-center justify-center transition-colors"
                      title="Reload Captcha"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        className="w-5 h-5 text-white"
                        fill="currentColor"
                      >
                        <path d="M12 6V3L8 7l4 4V8c2.76 0 5 2.24 5 5a5 5 0 11-8.9-2.96l-1.44-1.44A7 7 0 1019 13c0-3.87-3.13-7-7-7z" />
                      </svg>
                    </button>

                    <input
                      inputMode="numeric"
                      pattern="[0-9]*"
                      className="border px-3 py-1 w-32 rounded focus:outline-none focus:ring-2 focus:ring-teal-500"
                      placeholder="Enter Captcha"
                      value={captchaInput}
                      onChange={(e) => {
                        const numericValue = e.target.value.replace(/[^0-9]/g, "");
                        setCaptchaInput(numericValue);
                      }}
                      required
                    />
                  </div>

                  <div className="bg-blue-50 border border-blue-200 rounded-xl p-1">
                    <div className="flex items-start space-x-2">
                      <svg
                        className="w-5 h-5 text-blue-500 mt-0.5 flex-shrink-0"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                      <p className="text-blue-700 text-xs leading-relaxed">
                        Your credentials are securely encrypted and protected.
                      </p>
                    </div>
                  </div>
                </div>

                {errorMessage && (
                  <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded-lg text-left">
                    <p className="text-red-700 text-sm font-medium">
                      {errorMessage}
                    </p>
                  </div>
                )}

                <button
                  type="submit"
                  disabled={isLoading}
                  className={`w-full py-4 rounded-2xl text-white font-semibold text-base transition-all duration-200 shadow-lg ${
                    isLoading
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 active:scale-95"
                  }`}
                >
                  {isLoading ? (
                    <div className="flex items-center justify-center space-x-2">
                      <svg
                        className="w-5 h-5 animate-spin"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        />
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8v8H4z"
                        />
                      </svg>
                      <span>Logging in...</span>
                    </div>
                  ) : (
                    "Log In"
                  )}
                </button>
              </form>
               <p
                    className="text-teal-600 hover:text-teal-700 cursor-pointer text-sm font-medium"
                    onClick={() => setShowForgotPassword(true)}
                  >
                    Forgot Password?
                  </p>
            </div>
          </div>
        </div>

        {/* Desktop View */}
        <div
          className="hidden md:block absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white shadow-2xl rounded-2xl outline-none w-[90%] md:w-[80%] lg:w-auto 2xl:w-[900px] max-h-[80vh] overflow-y-auto"
          onClick={(e) => e.stopPropagation()}
        >
          <CloseIcon className="float-right rounded-full text-white" />

          <div className="flex flex-row justify-between items-center gap-5">
            <div className="flex items-center justify-center w-1/2">
              <div className="w-full max-w-sm">
                <img
                  src={LoginImg}
                  alt="Login"
                  className="w-full h-auto object-contain rounded-lg shadow-md"
                />
              </div>
            </div>

            <div className="w-1/2">
              <div className="text-center space-y-4">
                <div className="space-y-2">
                  <div className="w-full max-w-[150px] flex items-center justify-center mx-auto mb-3">
                    <img src={logo} alt="" className="" />
                  </div>
                  <p className="text-gray-600 text-sm leading-relaxed px-2">
                    Login to access your account
                  </p>
                </div>

                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleLogin();
                  }}
                  className="space-y-2"
                >
                  <div className="space-y-3 text-left">
                    <TextField
                      required
                      label="Username"
                      name="username"
                      value={formData.username}
                      fullWidth
                      size="small"
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "40px",
                          borderRadius: "12px",
                          fontSize: "14px",
                        },
                      }}
                    />

                    <TextField
                      required
                      label="Password"
                      name="password"
                      type={showPassword ? "text" : "password"}
                      value={formData.password}
                      fullWidth
                      size="small"
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "40px",
                          borderRadius: "12px",
                          fontSize: "14px",
                        },
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowPassword((prev) => !prev)}
                              edge="end"
                              size="small"
                              sx={{
                                p: 0.5,
                                "& svg": { fontSize: "1rem" },
                              }}
                            >
                              {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />

                    {/* Captcha Component - Desktop - Fixed */}
                    <div className="flex items-center space-x-1 justify-center">
                      <img
                        src={captcha}
                        alt="captcha"
                        className="w-28 h-9 border rounded" 
                      />

                      <button
                        type="button"
                        onClick={fetchCaptcha}
                        className="p-0.5 bg-blue-500 hover:bg-green-600 rounded-full flex items-center justify-center transition-colors"
                        title="Reload Captcha"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          className="w-5 h-5 text-white"
                          fill="currentColor"
                        >
                          <path d="M12 6V3L8 7l4 4V8c2.76 0 5 2.24 5 5a5 5 0 11-8.9-2.96l-1.44-1.44A7 7 0 1019 13c0-3.87-3.13-7-7-7z" />
                        </svg>
                      </button>

                      <input
                        inputMode="numeric"
                        pattern="[0-9]*"
                        className="border px-3 py-0.5 w-32 rounded focus:outline-none focus:ring-1 focus:ring-teal-500"
                        placeholder="Enter Captcha"
                        value={captchaInput}
                        onChange={(e) => {
                          const numericValue = e.target.value.replace(/[^0-9]/g, "");
                          setCaptchaInput(numericValue);
                        }}
                        required
                      />
                    </div>

                   <div className="bg-blue-50 border border-blue-200 rounded-xl">
  <div className="flex items-center justify-center gap-2 text-center">
    <svg
      className="w-3 h-3 text-blue-500 flex-shrink-0"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>

    <p className="text-blue-700 text-xs leading-relaxed">
      Your credentials are securely encrypted and protected.
    </p>
  </div>
</div>

                  </div>

                  {errorMessage && (
                    <div className="bg-red-50 border-l-4 border-red-400 p-1 rounded-lg text-left">
                      <p className="text-red-700 text-xs">{errorMessage}</p>
                    </div>
                  )}

                  <button
                    type="submit"
                    disabled={isLoading}
                    className={`w-full py-3 rounded-xl text-white font-semibold text-base transition-all duration-200 shadow-lg ${
                      isLoading
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700"
                    }`}
                  >
                    {isLoading ? (
                      <div className="flex items-center justify-center space-x-2">
                        <svg
                          className="w-5 h-5 animate-spin"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          />
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v8H4z"
                          />
                        </svg>
                        <span>Logging in...</span>
                      </div>
                    ) : (
                      "Log In"
                    )}
                  </button>

                  <p
                    className="text-teal-600 hover:text-teal-700 cursor-pointer text-sm font-medium"
                    onClick={() => setShowForgotPassword(true)}
                  >
                    Forgot Password?
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default MarketingLogin;
